<template>
  <v-form ref="form" v-model="valid">
    <v-container>
      <p class="text-h6">
        Enter cgID(s) delimited by line break
      </p>
      <v-row class="ml-6" align-content="center" no-gutters>
        <v-col cols="1">
          <p class="text-subtitle-1">
            CpG(s)
          </p>
        </v-col>
        <v-col cols="8" offset="1">
          <v-textarea
            v-model="input_cpg"
            required
            outlined
            dense
            rows="5"
            :rules="[requiredRule, limitCpg]"
            hint="Please try “cg01644611” if you don't have any specific cgID for the test."
            persistent-hint
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="12" lg="8" xl="8">
          <p class="text-h6">
            Filter options
          </p>
          <v-row class="ml-6 row-height" align-content="center" no-gutters>
            <v-col cols="1" sm="3" md="2" align-self="center">
              <p class="text-subtitle-1 mb-0">
                age
              </p>
            </v-col>
            <v-col cols="3" offset="1">
              <v-radio-group
                v-model="radio_age"
                row
              >
                <v-radio
                  label="All"
                  value="all"
                ></v-radio>
                <v-radio
                  label="Selected age range"
                  value="selected_age_range"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="1" offset="1" align-self="center">
              <v-text-field
                v-model.number="input_min_age"
                outlined
                dense
                :disabled="radio_age==='all'"
                type="number"
                hide-spin-buttons
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="1" align-self="center">
              <p class="text-subtitle-1 mb-0" style="text-align:center">～
              </p>
            </v-col>
            <v-col cols="1" align-self="center">
              <v-text-field
                v-model.number="input_max_age"
                outlined
                dense
                :disabled="radio_age==='all'"
                type="number"
                hide-spin-buttons
                hide-details
            ></v-text-field>
            </v-col>
            </v-row>

            <v-row class="ml-6" no-gutters>
              <v-col v-if="is_age_error" class="age-error" offset="3">{{ age_error_message }}</v-col>
            </v-row>
            <v-row class="ml-6 row-height" align-content="center" no-gutters>
              <v-col cols="1" sm="3" md="2"  align-self="center">
                <p class="text-subtitle-1 mb-0">
                  gender
                </p>
              </v-col>
              <v-col offset="1">
                <v-radio-group
                  v-model="radio_gender"
                  row
                >
                  <v-radio
                    label="All"
                    value="all"
                  ></v-radio>
                  <v-radio
                    label="Male"
                    value="male"
                  ></v-radio>
                  <v-radio
                    label="Female"
                    value="female"
                  ></v-radio>
                </v-radio-group>
              </v-col>
          </v-row>

          <v-row class="ml-6 row-height" align-content="center" no-gutters>
            <v-col cols="1" sm="3" md="2" align-self="center">
              <p class="text-subtitle-1 mb-0">
                handedeness
              </p>
            </v-col>
            <v-col offset="1">
              <v-radio-group
                v-model="radio_handedeness"
                row
              >
                <v-radio
                  label="All"
                  value="all"
                ></v-radio>
                <v-radio
                  label="Right"
                  value="right"
                ></v-radio>
                <v-radio
                  label="Left"
                  value="left"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="ml-6 row-height" align-content="center" no-gutters>
            <v-col cols="1" sm="3" md="2" align-self="center">
              <p class="text-subtitle-1 mb-0">
                MRI_Type
              </p>
            </v-col>
            <v-col offset="1">
              <v-radio-group
                v-model="radio_mri_type"
                row
              >
                <v-radio
                  label="All"
                  value="all"
                ></v-radio>
                <v-radio
                  label="1"
                  value="1"
                ></v-radio>
                <v-radio
                  label="2"
                  value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="mt-auto">
          <div v-if="search_result_message">
            <div class="search_result_message">
              {{ search_result_message }}
            </div>
            <div v-if="show_search_table">
              <v-data-table
                :headers="search_table_headers"
                :items="search_table_item"
                hide-default-header
                hide-default-footer
                dense
              ></v-data-table>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row class="justify-end mb-2 pr-3">
        <v-btn depressed color="primary" outlined style="text-transform: none;width: 30%;min-width: 200px;"
          :loading="search_loding"
          @click="search()">
          Search
        </v-btn>
      </v-row>

      <p class="text-h6">
        VBM model covariates options
        <span class="text-subtitle-1 ml-5" style="color: red;">＊: highly recommended to include the model</span>
      </p>
      <v-row class="ml-6 row-height" align-content="center" no-gutters>
        <v-col cols="1" sm="3" md="1" align-self="center">
          <p class="text-subtitle-1 mb-1">
            age
          </p>
        </v-col>
        <v-col offset="1" cols="1">
          <v-checkbox
            v-model="selected"
            value="age"
            :disabled="radio_age === 'selected_age_range' && input_min_age === input_max_age"
            label="＊"
            class="checkbox-label"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="ml-6 row-height" align-content="center" no-gutters>
        <v-col cols="1" sm="3" md="1" align-self="center">
          <p class="text-subtitle-1 mb-1">
            gender
          </p>
        </v-col>
        <v-col offset="1" cols="1">
          <v-checkbox v-model="selected" value="gender" :disabled="radio_gender!=='all'"
            label="＊"
            class="checkbox-label"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="ml-6 row-height" align-content="center" no-gutters>
        <v-col cols="1" sm="3" md="1" align-self="center">
          <p class="text-subtitle-1 mb-1">
            FSIQ
          </p>
        </v-col>
        <v-col offset="1" cols="1">
          <v-checkbox v-model="selected" value="FSIQ"></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="ml-6 row-height" align-content="center" no-gutters>
        <v-col cols="1" sm="3" md="1" align-self="center">
          <p class="text-subtitle-1 mb-1">
            handedeness
          </p>
        </v-col>
        <v-col offset="1" cols="1">
          <v-checkbox v-model="selected" value="handedeness" :disabled="radio_handedeness!=='all'"></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="ml-6 row-height" align-content="center" no-gutters>
        <v-col cols="1" sm="3" md="1" align-self="center">
          <p class="text-subtitle-1 mb-1">
            MRI_Type
          </p>
        </v-col>
        <v-col offset="1" cols="1">
          <v-checkbox v-model="selected" value="MRI_Type" :disabled="radio_mri_type!=='all'"
            label="＊"
            class="checkbox-label"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="ml-6 row-height" align-content="center" no-gutters>
        <v-col cols="1" sm="3" md="1" align-self="center">
          <p class="text-subtitle-1 mb-1">
            Total GMV
          </p>
        </v-col>
        <v-col offset="1" cols="1">
          <v-checkbox v-model="selected" value="GM" label="＊" class="checkbox-label"></v-checkbox>
        </v-col>
      </v-row>
      <p class="text-h6 mt-3 mb-0">
        Methylation β value option
      </p>
      <v-row class="ml-6" align-content="center" no-gutters>
        <v-col cols="3">
          <v-radio-group
            v-model="radio_mean"
            row
          >
            <v-radio
              label="M-value"
              value="m_value"
            ></v-radio>
            <v-radio
              label="Beta"
              value="beta"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <p class="text-h6 mt-3 mb-0">
        VBM statistical threshold settings
      </p>
      <v-row class="ml-6" align-content="center" no-gutters>
        <v-col cols="2" sm="2" md="3" >
          <v-radio-group
            v-model="radio_statistic"
            row
          >
            <v-radio
              label="p-value"
              value="p_value"
            ></v-radio>
            <v-radio
              label="FDR"
              value="fdr"
            ></v-radio>
             <v-radio
              label="FWER"
              value="fwer"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="1" sm="2" md="1" offset="1" offset-sm="2" offset-md="1" align-self="center" class="mt-3">
          <v-text-field
            v-if="radio_statistic==='p_value'"
            v-model.number="input_p_value"
            required
            auto-grow
            outlined
            dense
            rows="3"
            :rules="[thresholdRule]"
            type="number"
            hide-spin-buttons
          ></v-text-field>
          <v-text-field
            v-else-if="radio_statistic==='fdr'"
            v-model.number="input_FDR"
            required
            auto-grow
            outlined
            dense
            rows="3"
            :rules="[thresholdRule]"
            type="number"
            hide-spin-buttons
          ></v-text-field>
          <v-text-field
            v-else
            v-model.number="input_FWER"
            required
            auto-grow
            outlined
            dense
            rows="3"
            :rules="[thresholdRule]"
            type="number"
            hide-spin-buttons
          ></v-text-field>
        </v-col>
        <v-col align-self="center" class="pa-3 threshold-text">
          <p class="text--secondary mb-6">
            The statistical threshold can be set 0.2 or less
          </p>
        </v-col>
      </v-row>

      <v-row class="ml-6" align-content="center" no-gutters>
        <v-col cols="2" sm="2" md="3" align-self="center">
          <p class="text-subtitle-1 mb-6">
            cluster threshold
          </p>
        </v-col>
        <v-col cols="1" sm="2" md="1" offset="1" offset-sm="2" offset-md="1" align-self="center">
          <v-text-field
            v-model.number="input_cluster_threshold"
            required
            auto-grow
            outlined
            dense
            rows="3"
            :rules="[requiredRule]"
            type="number"
            hide-spin-buttons
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ml-6" align-content="center" no-gutters>
        <v-col>
          <v-radio-group
            v-model="radio_is_positive"
            row
            hint="One-sided statistics can run this analysis. Please choose which association direction to see."
            persistent-hint
            mandatory
          >
            <v-radio
              label="Positive"
              value="true"
            ></v-radio>
            <v-radio
              label="Negative"
              value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row class="justify-end pr-3">
        <v-btn depressed color="primary" style="text-transform: none;width: 30%;min-width: 200px;"
          :disabled="!valid"
          :loading="output_loding"
          @click="reportOutput()">
          Report output
        </v-btn>
      </v-row>

      <v-row class="justify-end pr-3 text--secondary">
        <div style="text-transform: none;width: 30%;min-width: 200px;">
          <p>It usually takes a few minutes. Please leave it after you hit the button until the resulting images and tables are out.</p>
        </div>
      </v-row>
      <v-row class="justify-end py-3" style="color: red;word-break: break-all;white-space: pre-line;">
        <v-col cols="12">
          <v-alert
            v-if="is_output_error"
            text
            dense
            type="error"
          >
            {{ output_error_message }}
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="show_report">
        <ReportForm :res-data="res_data"/>
      </v-row>
      <v-dialog
        v-model="dialog"
        persistent
        width="450"
      >
        <v-card height="150">
          <v-card-title class="text-subtitle-1">
            An error occurred while processing your request.<br />
            Please wait a moment and try again.
          </v-card-title>
          <v-card-actions>
            <v-btn
              @click="dialog = false"
              outlined
              color="red lighten-2"
              class="text-align:start ml-auto"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { getFunctions, httpsCallable } from 'firebase/functions'
import ReportForm from './ReportForm'

export default {
  name: 'SearchForm',
  components: {
    ReportForm
  },
  data () {
    return {
      valid: true,
      requiredRule: v => !!v || 'This field is required.',
      limitCpg: v => (v.split(/\n/).filter(e => e !== '')).length <= 10000 || 'Please enter CpG within 10,000.',
      thresholdRule: v => {
        if (v === '' || v === null) {
          return 'This field is required.'
        }
        if (v <= 0.2 && v > 0) {
          return true
        }
        return 'It accepts only 0.2 or less.'
      },
      input_cpg: '',
      input_min_age: null,
      input_max_age: null,
      selected: ['age', 'gender', 'FSIQ', 'handedeness', 'MRI_Type', 'GM'],
      input_p_value: 0.001,
      input_FDR: 0.05,
      input_FWER: 0.05,
      input_cluster_threshold: 10,
      radio_age: 'all',
      radio_gender: 'all',
      radio_handedeness: 'all',
      radio_mri_type: 'all',
      radio_statistic: 'p_value',
      radio_mean: 'm_value',
      radio_is_positive: 'true',
      search_loding: false,
      search_result_message: '',
      is_age_error: false,
      age_error_message: 'Please enter the correct value in the age field.',
      show_report: false,
      output_loding: false,
      res_data: null,
      is_output_error: false,
      output_error_message: '',
      dialog: false,
      show_search_table: false,
      search_table_headers: [
        { text: 'Search result', align: 'start', value: 'name' },
        { text: 'Search result count', value: 'search_result' }
      ],
      search_table_item: [
        { name: 'Average age', search_result: null },
        { name: 'Female', search_result: null },
        { name: 'Righthanded', search_result: null },
        { name: 'MRI type 1', search_result: null }
      ]
    }
  },
  methods: {
    async search () {
      this.ageRules() // 年齢相関チェック
      this.search_result_message = '' // 検索結果メッセージ初期化
      this.show_search_table = false
      this.search_table_item[0].search_result = null
      this.search_table_item[1].search_result = null
      this.search_table_item[2].search_result = null
      this.search_table_item[3].search_result = null
      if (!this.is_age_error) {
        this.search_loding = true
        const req = {
          min_age: this.radio_age === 'selected_age_range' ? this.input_min_age : null,
          max_age: this.radio_age === 'selected_age_range' ? this.input_max_age : null,
          selected_gender: this.radio_gender,
          selected_handedeness: this.radio_handedeness,
          selected_mri: this.radio_mri_type
        }
        try {
          const functions = getFunctions()
          const res = await httpsCallable(functions, 'loadMethylFile')(req)
          this.search_loding = false
          if (res.data.result_row > 0) {
            this.search_result_message = `${JSON.stringify(res.data.result_row)} out of ${JSON.stringify(res.data.all_row)} cases were applicable.`
            this.search_table_item[0].search_result = Number(res.data.result_average_age)
            this.search_table_item[1].search_result = res.data.result_female
            this.search_table_item[2].search_result = res.data.result_righthanded
            this.search_table_item[3].search_result = res.data.result_mri_type
            this.show_search_table = true
          } else {
            this.search_result_message = 'Not applicable.'
          }
        } catch (e) {
          console.log(e)
          this.search_loding = false
          this.dialog = true
        }
      }
    },
    async reportOutput () {
      this.ageRules() // 年齢相関チェック
      this.output_error_message = '' // レポート出力時エラーメッセージ初期化
      this.is_output_error = false
      this.show_report = false
      if (this.$refs.form.validate() && !this.is_age_error) {
        this.output_loding = true
        const setSelectedVal = () => { // slectedの値設定
          if (this.radio_age === 'selected_age_range' && this.input_min_age === this.input_max_age) {
            this.selected = this.selected.filter(e => e !== 'age')
          }
          if (this.radio_gender !== 'all') {
            this.selected = this.selected.filter(e => e !== 'gender')
          }
          if (this.radio_handedeness !== 'all') {
            this.selected = this.selected.filter(e => e !== 'handedeness')
          }
          if (this.radio_mri_type !== 'all') {
            this.selected = this.selected.filter(e => e !== 'MRI_Type')
          }
          return this.selected
        }
        const cpg = this.input_cpg.split(/\n/).filter(e => e !== '')
        const req = {
          cpg: cpg,
          min_age: this.radio_age === 'selected_age_range' ? this.input_min_age : null,
          max_age: this.radio_age === 'selected_age_range' ? this.input_max_age : null,
          selected_gender: this.radio_gender,
          selected_handedeness: this.radio_handedeness,
          selected_mri: this.radio_mri_type,
          selected: setSelectedVal(),
          radio_statistic: this.radio_statistic,
          p_value: this.radio_statistic === 'p_value' ? this.input_p_value : null,
          FDR: this.radio_statistic === 'fdr' ? this.input_FDR : null,
          FWER: this.radio_statistic === 'fwer' ? this.input_FWER : null,
          m_value: this.radio_mean === 'm_value',
          cluster_threshold: this.input_cluster_threshold,
          is_positive: JSON.parse(this.radio_is_positive.toLowerCase())
        }
        try {
          const functions = getFunctions()
          const res = await httpsCallable(functions, 'callVBMAnalysis', { timeout: 540 * 1000 })(req)
          this.output_loding = false
          if (res.data.diff) { // CpG該当なしメッセージ表示
            this.show_report = false
            this.output_error_message = `The entered CpG does not match the database.
                                        ${JSON.stringify(res.data.diff)}`
            this.is_output_error = true
          } else if (res.data.status === 'NO_TARGET_DATA') { // 解析対象データなし
            this.show_report = false
            this.output_error_message = 'Analysis data does not exist.'
            this.is_output_error = true
          } else {
            this.is_output_error = false
            this.res_data = res.data
            this.show_report = true
          }
        } catch (e) {
          console.log(e)
          this.output_loding = false
          this.dialog = true
        }
      }
    },
    ageRules () {
      if (this.radio_age === 'selected_age_range') {
        if (!this.input_min_age && !this.input_max_age) {
          this.is_age_error = true
        } else if (this.input_min_age && this.input_max_age) {
          this.is_age_error = this.input_min_age > this.input_max_age
        } else {
          this.is_age_error = false
        }
      } else {
        this.is_age_error = false
      }
    }
  }
}
</script>

<style scoped>
.age-error {
  font-size: small;
  color: #FF5252;
}
.checkbox-label /deep/ label {
  color: red;
}
.row-height {
  height: 50px;
}
.v-data-table table {
  max-width: 50;
}
.search_result_message {
  font-weight: bolder;
  font-size: 1.1em;
}
.threshold-text{
  font-size: 0.7em;
}
</style>
